import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=4e987bec&"
import script from "./UserEdit.vue?vue&type=script&lang=ts&"
export * from "./UserEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports